import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'da' ? 'en' : 'da';
    i18n.changeLanguage(newLang);
  };

  const isDanish = i18n.language === 'da';

  return (
    <div className="absolute top-3 right-3 z-40">
      <div className="bg-white rounded-full p-0.5 shadow-md border border-[#006B5F]/20">
        <div className="flex items-center space-x-0.5">
          {/* Danish option */}
          <button
            onClick={() => i18n.changeLanguage('da')}
            className={`flex items-center px-2 py-1 rounded-full transition-all duration-200 ${
              isDanish
                ? 'bg-[#006B5F] text-white shadow-sm'
                : 'text-gray-600 hover:text-[#006B5F] hover:bg-gray-50'
            }`}
          >
            <span className="text-xs mr-0.5">🇩🇰</span>
            <span className="text-xs font-medium">DA</span>
          </button>

          {/* English option */}
          <button
            onClick={() => i18n.changeLanguage('en')}
            className={`flex items-center px-2 py-1 rounded-full transition-all duration-200 ${
              !isDanish
                ? 'bg-[#006B5F] text-white shadow-sm'
                : 'text-gray-600 hover:text-[#006B5F] hover:bg-gray-50'
            }`}
          >
            <span className="text-xs mr-0.5">🇬🇧</span>
            <span className="text-xs font-medium">EN</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
